import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Offcanvas, Container } from 'react-bootstrap';
import Logo from '../Medias/Logos/logo_h.png';
import logoPT from '../Medias/LogosPT/logo_h.png';
import { BsGlobe } from "react-icons/bs";

const MainMenu = ({ contents = { routePath: { currentPath: '/' } } }) => {
  const expand = 'xxl';
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const openOffcanvas = () => {
    console.log("openOffcanvas");
    setShowOffcanvas(true);
  }

  const closeOffcanvas = () => {
    console.log("closeOffcanvas");
    setShowOffcanvas(false);
  }

  const scrollToTarget = (v_target) => {
    var target = document.getElementById(v_target);
    window.scrollTo({
      top: target.offsetTop - 125,
      behavior: 'smooth'
    });
    closeOffcanvas();
  }

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Navbar expand={expand} id="main-menu" fixed="top" bg='white-trans' className={`main-navbar ${scrolled ? 'scrolled' : ''}`}>
        <Container className='px-3 px-md-0'>
          <Navbar.Brand as={Link} to="/">
            <img src={logoPT} className="logo logo-pt mx-0 me-3" alt="Logo" />
          </Navbar.Brand>
          {/* <Navbar.Brand as={Link} to="http://pta-energylawcenter.com" target='_blank'>
            <img src={Logo} className="logo mx-0" alt="Logo" />
            <BsGlobe className='ms-1 mt-4' />
          </Navbar.Brand> */}
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} onClick={openOffcanvas} />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
            placement="end"
            show={showOffcanvas}
            onHide={closeOffcanvas}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <img src={logoPT} className="logo mx-0 me-0" alt="Logo" style={{ height: '30px' }} />
                <img src={Logo} className="logo mx-3" alt="Logo" />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/">Home</Nav.Link>
                {/* <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/OurFirm">Our Firm</Nav.Link> */}
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/About">About Us</Nav.Link>
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/OurTeam">Our Team</Nav.Link>
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/Service">Our Services</Nav.Link>
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/OurClient">Our Clients</Nav.Link>
                {/* 
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/EnergyLawCenter">Energy Law Center</Nav.Link>
                <NavDropdown title="Resources" id="resource-dropdown" className='px-2'>
                  <NavDropdown.Item className="text-black" as={Link} to="/Publication">Publications</NavDropdown.Item>
                  <NavDropdown.Item className="text-black" as={Link} to="/NewsAndEvents">News &amp; Events</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Energy Law Center" id="energy-dropdown" className='px-2'>
                  <NavDropdown.Item className="text-black" as={Link} to="/Regulatory">Regulatory Updates</NavDropdown.Item>
                  <NavDropdown.Item className="text-black" as={Link} to="/EnergyTrend">Energy Trends</NavDropdown.Item>
                </NavDropdown> */}
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/Network">Our Network</Nav.Link>
                <Nav.Link onClick={closeOffcanvas} className="text-black px-2" as={Link} to="/Contact">Contact Us</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  )
}

export default MainMenu